<template>
 <v-dialog  width="1000px" :value="show" @input="$emit('change-value', $event)">
    <v-card height="450px">
      <v-card-text class="h-100 pb-0">
        <v-layout column h-100>
          <v-flex>
            <vue-perfect-scrollbar >
              <v-data-table
                :headers="headers"
                :items="data"
                hide-actions
                no-data-text="No se encontraron registros"
                class="bordered mx-4 b-borders dataScroll">
                <template slot="headerCell" slot-scope="props" class="k-orange-linear">
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                </template>
                <template  slot="items" slot-scope="props">
                  <td>
                    {{ props.item.date }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.one) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.two) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.three) }}
                  </td>
                  <td>
                    {{ new Intl.NumberFormat('es-VE').format(props.item.four) }}
                  </td>
                </template>
              </v-data-table>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex>
            <v-layout class="h-100 ma-0" justify-end align-end>
              <v-btn flat  @click="$emit('change-value', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      active: null,
      cancelToken: this.axios.CancelToken.source(),
      headers: [
        {
          text: 'Fecha',
          align: 'left',
          value: 'day',
          sortable: false,
        },
        {
          text: 'Archivo de lectura',
          align: 'left',
          value: 'one',
          sortable: false,
        },
        {
          text: 'Antes de filtros',
          align: 'left',
          value: 'two',
          sortable: false,
        },
        {
          text: 'Despues de filtros',
          align: 'left',
          value: 'three',
          sortable: false,
        },
        {
          text: 'Cargados',
          align: 'left',
          value: 'four',
          sortable: false,
        },
      ],
      data: [],
    };
  },
  methods: {
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    search() {
      this.cancelRequest();
      this.data = [];
      this.axios.get('daily_load/report/perDay', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
          dateType: 'month',
          groupBy: 'date',
        },
      }).then((res) => {
        const data = res.data.stages || {};
        const totals = res.data.all;
        for (let i = 0; i < data.length; i += 1) {
          // eslint-disable-next-line
          data[i][1] = totals.find(x => x.date === Number(data[i].date)).total;
        }
        let month = this.filters.date.split('-');
        month = `${month[0]}${month[1]}`;
        for (let i = 0; i < 31; i += 1) {
          let date = `${month}${i < 9 ? '0' : ''}${i + 1}`;
          const position = data.find(x => x.date === Number(date)) || {};
          date = moment(date, 'YYYYMMDD').format('DD/MM/YYYY');
          if (date !== 'Invalid date') {
            this.$set(this.data, i, {
              date,
              one: Number(position[1]) || 0,
              two: Number(position[2]) || 0,
              three: Number(position[3]) || 0,
              four: Number(position[4]) || 0,
            });
          }
        }
      }).catch(() => {});
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          this.search();
        } else {
          this.cancelRequest();
        }
      },
    },
  },
};
</script>
<style scoped>
.dataScroll {
  max-height: 386px;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/DailyLoad/Historic.vue